
// export const LotteryContract = "0x62Cd04d562FbDaDF918DE64F8c838d6b7c691d08";   // "0x367c9614ef58A4F42a944F0893C898CaafECe140" // sepolia
export const LotteryContract = "0xD52031276fFFFD04D987E4f6e5cc139024C0b412" //"0x4885a480DDC3B489a2D5DB0eA1DCc08889bB3bDA"; // bSC Testnet
export const LotterytokenSymbol= "CAKE";

